export const JOYRIDE_STEPS = [
  {
    target: '.C-Layout__globalActions',
    content: 'Unified Application User profile and settings: Placeholder Test',
  },
  {
    target: '.C-SideNav__Navigation',
    content: 'Unified Products Menus: Placeholder',
  },
  {
    target: '.home-header-card',
    content: 'Unified Application Details: Placeholder',
  },
  {
    target: '.home-app-cards',
    content: 'Unified Products Details: Placeholder',
  },
  {
    target: '.home-relase-cards',
    content: 'Unified Products Release Notes: Placeholder',
  },
]

export const APP_CONSTANTS = {
  KEY_APP_CONFIG: 'appConfig',
}

/**
 * Standard HTTP header parameter keys used throughout the application.
 */
export const HEADER_PARAM = {
  AUTHORIZATION: 'Authorization',
  X_API_KEY: 'x-api-key',
  ID2_TOKEN: 'x-id2-token',
}

/**
 * Keys used for storing authentication tokens in memory.
 */
export const MEMORY_KEY = {
  ACCESS_TOKEN: 'access_token',
  ID_TOKEN: 'id_token',
}
